/* JS for lib/actions.html */

$(document).ready(() => {
    /**
     * Handles API request for bookmarking/saving/removing video from playlist.
     * On successful action, displays notification alert with message received in response.
     * @param {jQuery event} event
     */
    const handleSaveVideoToPlaylistRequest = (event) => {
        event.preventDefault();
        const $this = $(event.currentTarget);

        const url = $this.attr('href');
        const csrftoken = Cookies.get('csrftoken');

        $.ajax({
            url,
            type: 'POST',
            headers: { 'X-CSRFToken': csrftoken },
            success: (response) => {
                const alert_message = `<div data-alert="alert" class="fade in alert ${
                    response.add_class || 'alert-success'
                }"><button type="button" class="close" data-dismiss="alert">x</button> ${
                    response.message || 'Updated successfully!'
                }</div>`;
                $('#alerts').append(alert_message);

                // If new url provided, update it
                if (response.url) {
                    $this.attr('href', response.url);
                }

                // If label text should be updated
                if (response.update_text) {
                    const $textLabel = $('span[id$="text"]', $this);
                    $textLabel && $textLabel.html(response.update_text);
                }

                // displays notification
                $('.alert').addClass('show');

                // removes notification after 4 seconds
                window.setTimeout(() => {
                    $('.alert')
                        .fadeTo(500, 0)
                        .slideUp(500, () => {
                            $('.alert').remove();
                        });
                }, 4000);
            },
            error: (request) => {
                if (request.status === 401) {
                    const data = request.responseJSON;
                    window.location.href = data.redirect_url;
                }
            },
        });
    };

    /**
     * Assign event handler for bookmarking and adding video to playlist
     */
    $('#bookmark, .playlist-add-remove').on('click', handleSaveVideoToPlaylistRequest);

    $('.js_shareDropdown').one('shown.bs.dropdown', () => {
        window.twttr = (function (d, s, id) {
            let js;
            const fjs = d.getElementsByTagName(s)[0];
            const t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://platform.twitter.com/widgets.js';
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function (f) {
                t._e.push(f);
            };
            return t;
        })(document, 'script', 'twitter-wjs');
    });

    $("button[type='submit']", "div[id$='share-modal']").click((event) => {
        $("div[id$='share-modal']").click((event) => {
            const data = event.currentTarget.dataset;
            save_share_method(data.csrf_token, data.object_id, data.content_type, data.url, 'email');
        });
    });

    window.addEventListener('industryvideo:moreinfo', (event) => {
        more_info(event.detail.url);
    });
    window.addEventListener('video_with_actions_enabled_fields:moreinfo', (event) => {
        more_info(event.detail.url);
    });
});

let shared_twitter = false;
let shared_email = false;
let shared_object_id = null;
let shared_object_type = null;

function save_share_method(csrf, id, type, url, share_method) {
    if (share_method == 'twitter') {
        if (!shared_twitter) {
            $.ajaxSetup({
                beforeSend(xhr, settings) {
                    xhr.setRequestHeader('X-CSRFToken', csrf);
                },
            });
            $.ajax({
                method: 'POST',
                url,
                data: {
                    share_method,
                    object_id: id,
                    content_type: type,
                },
                csrfmiddlewaretoken: csrf,
            }).done(() => {
                shared_twitter = true;
            });
        }
    } else if (share_method == 'email') {
        if ((!shared_email || shared_object_id !== id, shared_object_type !== type)) {
            $.ajaxSetup({
                beforeSend(xhr, settings) {
                    xhr.setRequestHeader('X-CSRFToken', csrf);
                },
            });
            $.ajax({
                method: 'POST',
                url,
                data: {
                    share_method,
                    object_id: id,
                    content_type: type,
                },
                csrfmiddlewaretoken: csrf,
            }).done(() => {
                shared_email = true;
                shared_object_id = id;
                shared_object_type = type;
            });
        }
    }
}

function submit_contact_me(form) {
    $.ajax({
        data: form.serialize(),
        type: form.attr('method'),
        url: form.attr('action'),
        success(response) {
            if ($.trim($('.more-info-content').html()).length < 1) {
                const contactMeButton = $('.contact-me-btn');
                if (contactMeButton.is('input')) {
                    contactMeButton.val(response.message);
                } else {
                    contactMeButton.text(response.message);
                }
                contactMeButton.prop('disabled', true);
            } else {
                $('#ajax-response').html(`<p>${response.message}</p>`);
                $('#ajax-response').delay(5000).fadeOut(2000);
            }
        },
    });
}

function more_info(url) {
    // Called in actions.html ~L60 Used to submit contact me on content item display
    if ($.trim($('.more-info-content').html()).length > 0) {
        $('#hidden-contact-me-btn').click(() => {
            $('.more-info-show').show();
        });
    }

    $('#hidden-contact-me').submit(function (event) {
        event.preventDefault();
        submit_contact_me($(this));
        if (url) {
            openInNewTab(url);
        }
        return false;
    });
}

$(document).on('click', '.contactme-submit', function (e) {
    const form = $(this).parents('form');
    submit_contact_me(form);
});
